import { render } from "./QwCollapseItem.vue?vue&type=template&id=3bb7398e"
import script from "./QwCollapseItem.vue?vue&type=script&lang=js"
export * from "./QwCollapseItem.vue?vue&type=script&lang=js"

import "./QwCollapseItem.vue?vue&type=style&index=0&id=3bb7398e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__